require('./../scss/main.scss');

// Shared JS imports
require('../../shared/js/preload');
require('../../shared/js/svg-lazyload');
require('../../shared/js/image-fader');

// Require all js files in /js
function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./non-critical/', true, /\.js$/));